module.exports = __webpack_public_path__ + "static/media/YF92_6.e553862c.jpg";